class ContactFaq extends HTMLElement {
  #controller = new AbortController();

  get #initialVisible() {
    return Number(this.dataset.visibleCount) || 7;
  }

  get #list() {
    return this.querySelector('.contact-faq__list');
  }

  get #items() {
    return this.querySelectorAll('.contact-faq__item');
  }

  get #loadMoreBtn() {
    return this.querySelector('.contact-faq__load-more');
  }

  get #filters() {
    return this.querySelectorAll('.contact-faq__filter');
  }

  get #filterDot() {
    return this.querySelector('.contact-faq__filter-dot');
  }

  #activeFilter = 'all';

  connectedCallback() {
    const { signal } = this.#controller;

    /* Single-open accordion */
    if (this.#list) {
      this.#list.addEventListener('toggle', this.#handleToggle, { capture: true, signal });
    }

    /* Load More click */
    if (this.#loadMoreBtn) {
      this.#loadMoreBtn.addEventListener('click', this.#handleLoadMore, { signal });
    }

    /* Category filters */
    this.#filters.forEach((filter) => {
      filter.addEventListener('click', this.#handleFilterClick, { signal });
    });

    /* Initial visibility */
    this.#applyVisibility();
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  #handleToggle = (e) => {
    if (e.target.open) {
      this.#list.querySelectorAll('details').forEach((detail) => {
        if (detail !== e.target && detail.open) {
          detail.open = false;
        }
      });
    }
  };

  #handleLoadMore = () => {
    this.#items.forEach((item) => {
      if (item.classList.contains('contact-faq__item--hidden-overflow')) {
        item.style.display = '';
        item.classList.remove('contact-faq__item--hidden-overflow');
      }
    });
    this.#loadMoreBtn.style.display = 'none';
  };

  #handleFilterClick = (e) => {
    const filter = e.currentTarget;
    this.#filters.forEach((f) => f.classList.remove('contact-faq__filter--active'));
    filter.classList.add('contact-faq__filter--active');
    filter.prepend(this.#filterDot);
    this.#activeFilter = filter.getAttribute('data-filter');
    this.#applyVisibility();
  };

  #applyVisibility() {
    let visibleIndex = 0;
    let hiddenCount = 0;

    this.#items.forEach((item) => {
      const cat = item.getAttribute('data-category');
      const matchesFilter = this.#activeFilter === 'all' || cat === this.#activeFilter;

      if (!matchesFilter) {
        item.style.display = 'none';
        item.open = false;
        item.classList.remove('contact-faq__item--hidden-overflow');
        return;
      }

      if (visibleIndex < this.#initialVisible) {
        item.style.display = '';
        item.classList.remove('contact-faq__item--hidden-overflow');
      } else {
        item.style.display = 'none';
        item.classList.add('contact-faq__item--hidden-overflow');
        item.open = false;
        hiddenCount++;
      }
      visibleIndex++;
    });

    if (this.#loadMoreBtn) {
      this.#loadMoreBtn.style.display = hiddenCount > 0 ? '' : 'none';
    }
  }
}

if (!customElements.get('contact-faq')) {
  customElements.define('contact-faq', ContactFaq);
}
